
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";

// Template Dashboard 2 MUI helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { dark } = colors;
const { size, fontWeightBold } = typography;

const formControlLabel = {
  styleOverrides: {
    root: {
      
    },

    label: {
      
    },
  },
};

export default formControlLabel;
